export const FILE_DOWNLOAD_OPEN_TYPES = {
  OPEN: "open",
  DOWNLOAD: "download",
};
